import { Tabs, TabsList, TabsTrigger } from "../tabs/Tabs";

const OverviewTabs = ({ options, defaultTabValue = "all", tabs }) => {
  return (
    <Tabs defaultValue={defaultTabValue}>
      <div className="flex items-center">
        <TabsList>
          {tabs &&
            tabs.map((tab, index) => (
              <TabsTrigger
                key={`tab_trigger_${tab.trigger.value}_${index}`}
                value={tab.trigger.value}
                className={tab.trigger.value !== "all" ? "hidden sm:block" : ""}
              >
                {tab.trigger.label}
              </TabsTrigger>
            ))}
        </TabsList>
        <div className="ml-auto flex items-center justify-end gap-x-1">
          {options}
        </div>
      </div>
      {tabs &&
        tabs.map((tab, index) => {
          return (
            <div key={`tab_content_${tab.trigger.value}_${index}`}>
              {tab.content}
            </div>
          );
        })}
    </Tabs>
  );
};

export default OverviewTabs;
